import { render, staticRenderFns } from "./TestCheckpoint.vue?vue&type=template&id=673beb3c&scoped=true"
import script from "./TestCheckpoint.vue?vue&type=script&lang=js"
export * from "./TestCheckpoint.vue?vue&type=script&lang=js"
import style0 from "./TestCheckpoint.vue?vue&type=style&index=0&id=673beb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673beb3c",
  null
  
)

export default component.exports